<ng-container *ngIf="showComponent">
  <!-- Content-only mode: render suggestions without an expansion panel -->
  <ng-container *ngIf="panelSections === 'contentOnly'; else withPanel">
    <ng-container class="word" *ngFor="let s of visibleSuggestions; let i = index; trackBy: trackByFn">
      <app-suggestion
        [suggestion]="s"
        [thisItemPath]="childItemPaths[s.rank ?? i]"
        (requestReplace)="onSuggestionReplacement($event)"
      >
      </app-suggestion>
    </ng-container>
    <button *ngIf="hasMoreSuggestions" class="show-more-btn" (click)="toggleShowAll()">
      Show {{ hiddenCount }} more
    </button>
  </ng-container>

  <!-- Default / headerOnly / all modes -->
  <ng-template #withPanel>
    <mat-expansion-panel
      class="word-expansion-panel"
      [expanded]="panelOpenState"
      (opened)="onOpened()"
      (closed)="onClosed()"
      [attr.aria-label]="'Spelling suggestions for ' + word.input"
    >
      <!-- HEADER -->
      <mat-expansion-panel-header *ngIf="panelSections === 'all' || panelSections === 'headerOnly'">
        <mat-panel-title>
          <span class="word-token">{{ word.input }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- CONTENT -->
      <ng-container *ngIf="panelSections === 'all' || panelSections === 'contentOnly'">
        <ng-container class="word" *ngFor="let s of visibleSuggestions; let i = index; trackBy: trackByFn">
          <app-suggestion
            [suggestion]="s"
            [thisItemPath]="childItemPaths[s.rank ?? i]"
            (requestReplace)="onSuggestionReplacement($event)"
          >
          </app-suggestion>
        </ng-container>
        <button *ngIf="hasMoreSuggestions" class="show-more-btn" (click)="toggleShowAll()">
          Show {{ hiddenCount }} more
        </button>
      </ng-container>
    </mat-expansion-panel>
  </ng-template>
</ng-container>
